

































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ListField, ListFields } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";
import { languageList } from "@/views/PageBecomeCreator/config";

export default defineComponent({
  name: "FilterLanguage",
  components: { BaseButton, BaseIcon, CustomScroll, BaseInput },
  props: {
    value: { type: Array as PropType<string[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const language = ref("");
    const showOptions = ref(false);
    const options = ref<ListFields>([]);
    const selectedLanguages = ref<ListFields>([]);
    const isSelectedFilters = computed(() => !!props.value.length);

    const optionsToSelect = computed(() => options.value.filter(i => !selectedLanguages.value.includes(i)));

    const getLanguage = async (text?: string) => {
      if (!text) {
        showOptions.value = false;
        return;
      }
      options.value = languageList.filter(item => item.text.toLowerCase().includes(text.toLowerCase()));
      showOptions.value = !!optionsToSelect.value.length;
    };

    const setLanguage = (value: ListField) => {
      showOptions.value = false;
      language.value = "";
      selectedLanguages.value.push(value);
      emit(
        "input",
        selectedLanguages.value.map(i => i.value)
      );
    };

    const excludeLanguage = (value: string) => {
      selectedLanguages.value = selectedLanguages.value.filter(item => item.value !== value);
      emit(
        "input",
        selectedLanguages.value.map(i => i.value)
      );
    };

    const clear = () => {
      selectedLanguages.value = [];
      emit("input", selectedLanguages.value);
    };

    const created = () => {
      if (!props.value.length) return;
      selectedLanguages.value = languageList.filter(item => props.value.includes(item.value));
    };

    created();

    return {
      language,
      showOptions,
      optionsToSelect,
      selectedLanguages,
      isSelectedFilters,
      getLanguage,
      setLanguage,
      excludeLanguage,
      clear,
    };
  },
});
